import React, { useState } from 'react';
import { Link, Popover } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';

export const MulchTooltip = () => {

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const textContent = (
    <div>
      <p className="sui-pt-2">
        <span className="sui-underline">Wood mulch</span>
          &nbsp;breaks down after a season or two and needs to be reapplied.
          &nbsp;It actually enhances the soil by adding vital nutrients as it deteriorates.
      </p>
      <p className="sui-pt-2">
        <span className="sui-underline">Rubber mulch</span>
          &nbsp;is more permanent, but does not improve the soil structure.
      </p>
      <p className="sui-pt-2">
        <span className="sui-underline">Top Soil</span>
        &nbsp;is a ready-to-use soil useful for filling in holes and patching bare spots on
        lawns.
      </p>
    </div>
  );
  return (
    <>
      <div className="sui-flex sui-items-center sui-mt-3 sui-mb-3">
        {/* @todo: clean inline style once Stencil fixes the icon invisible bottom padding */}
        <div className="sui-mr-1" style={{ 'margin-bottom': '-5px' }}><InfoFilled size="small" color="info" /></div>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link component="button" underline="none" color="info" onClick={handleClick}>What kind should I
          choose?
        </Link>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          placement="bottom"
          title="What kind should I choose?"
        >
          {textContent}
        </Popover>
      </div>
    </>
  );
};
